import { render, staticRenderFns } from "./PPCAddComment.vue?vue&type=template&id=33c18504&scoped=true&"
import script from "./PPCAddComment.vue?vue&type=script&lang=js&"
export * from "./PPCAddComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c18504",
  null
  
)

export default component.exports